// extracted by mini-css-extract-plugin
export default {"heroTitle":"Header_heroTitle__aL6CY","actionButton":"Header_actionButton__emlhA"};